import request from '@/utils/request'
import { data } from 'jquery'
const BASE_URL = '/TeachersInfo'


export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  getLast5Year(id) {
    return request({
      url: BASE_URL + '/GetLast5Year',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  updateFace(data) {
    return request({
      url: BASE_URL + '/UpdateFace',
      method: 'post',
      data
    })
  },
  getDormitorys(id) {
    return request({
      url: BASE_URL + '/getDormitorys',
      method: 'get',
      params: { id }
    })
  },
  saveDormitorys(data) {
    return request({
      url: BASE_URL + '/SaveDormitorys',
      method: 'post',
      data
    })
  },
  updateAccoutStatus(data) {
    return request({
      url: BASE_URL + '/UpdateAccoutStatus',
      method: 'post',
      data
    })
  },
  import: "/api" + BASE_URL + "/Import",
  importUpdate: "/api" + BASE_URL + "/ImportUpdate",
  importCheck: "/api" + BASE_URL + "/ImportCheck",
  importJob: "/api" + BASE_URL + "/ImportJob",
  getMsgClassIds(data) {
    return request({
      url: BASE_URL + '/GetMsgClassIds',
      method: 'get',
      params: {
        TermId: data.TermId,
        TeacherId: data.TeacherId,
      }
    })
  },
  getMsgClasses(termId, teacherId, gradeId) {
    return request({
      url: BASE_URL + '/GetMsgClasses',
      method: 'get',
      params: { termId, teacherId, gradeId }
    })
  },
  saveMsg(data) {
    return request({
      url: BASE_URL + '/SaveMsg',
      method: 'post',
      data
    })
  },
  //计算德育年限
  buildEduJob() {
    return request({
      url: BASE_URL + '/BuildEduJob',
      method: 'post',
    })
  },
  export(data) {
    return request({
      url: BASE_URL + '/Export',
      method: 'post',
      responseType: 'blob',
      data
    }).then(res => {
      var file = res.data;
      var disposition = res.headers['content-disposition'];
      // console.log('disposition', disposition);

      var fileName = "导出";
      if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
        var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
        fileName = decodeURI(text);
      }

      if (navigator.msSaveBlob) {
        // IE10+下载
        navigator.msSaveBlob(file, fileName);
      } else {
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.target = "_blank";
        elink.href = URL.createObjectURL(file);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }
      return Promise.resolve();
    });
  },
  exportAccount(data) {
    return request({
      url: BASE_URL + '/ExportAccount',
      method: 'post',
      responseType: 'blob',
      data
    }).then(res => {
      var file = res.data;
      var disposition = res.headers['content-disposition'];
      // console.log('disposition', disposition);

      var fileName = "导出";
      if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
        var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
        fileName = decodeURI(text);
      }

      if (navigator.msSaveBlob) {
        // IE10+下载
        navigator.msSaveBlob(file, fileName);
      } else {
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.target = "_blank";
        elink.href = URL.createObjectURL(file);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }
      return Promise.resolve();
    });
  },
  getWxConfig() {
    return request({
      url: BASE_URL + '/GetWxConfig',
      method: 'get',
    })
  },
  updateDefaultTag(data) {
    return request({
      url: BASE_URL + '/UpdateDefaultTag',
      method: 'post',
      data
    })
  },
  batchTag(data) {
    return request({
      url: BASE_URL + '/BatchTag',
      method: 'post',
      data
    })
  }
}